import { mutatorAction } from 'satcheljs';
import getStore from '../store/appHostSearchStore';

export const onAppClearSearchListenersMutator: () => void = mutatorAction(
    'onAppClearSearchListeners',
    (): void => {
        const store = getStore();
        store.isSearchEnabled = false;
        store.eventRegistrationsMap.clear();
    }
);
